function c() {
  var o;
  return {
    before: function before(_ref) {
      var e = _ref.doc;
      var l;
      var n = e.documentElement;
      o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
    },
    after: function after(_ref2) {
      var e = _ref2.doc,
          n = _ref2.d;
      var t = e.documentElement,
          l = t.clientWidth - t.offsetWidth,
          r = o - l;
      n.style(t, "paddingRight", "".concat(r, "px"));
    }
  };
}

export { c as adjustScrollbarPadding };